import {Operator} from './operator';

export class Program {

  constructor(
    public id: string,
    public operator?: Operator,
    public programName?: string,
    public displayLabel?: string,
    public shortDisplayLabel?: string,
    public status?: string
  ) {
  }

  static newInstance(id: string, operatorId?: string, programName?: string, displayLabel?: string, shortDisplayLabel?: string, status?: string) {
    return new Program(id, new Operator(operatorId), programName, displayLabel, shortDisplayLabel, status);
  }

  clone(): Program {
    return new Program(this.id, this.operator, this.programName, this.displayLabel, this.shortDisplayLabel, this.status);
  }

}
